import * as types from 'src/state/ducks/orderBread/types';
import { OrderBreadEntity } from 'src/firebase/db/OrderBreads';
import { APISuccessfulResponse, APIFailedResponse } from 'src/firebase/db/DatabaseAdapter';
import { ValidationResponse } from 'src/firebase/db/ValidationManager';

export type Actions =
  | GetOrderBread
  | SuccessGetOrderBread
  | FailGetOrderBread
  | GetOrderBreads
  | SuccessGetOrderBreads
  | FailGetOrderBreads
  | GetNotificationOrderBreads
  | SuccessGetNotificationOrderBreads
  | FailGetNotificationOrderBreads
  | GetDayOrderBreads
  | SuccessGetDayOrderBreads
  | FailGetDayOrderBreads
  | ValidateOrderBread
  | SuccessValidateOrderBread
  | FailValidateOrderBread
  | CreateOrderBread
  | SuccessCreateOrderBread
  | FailCreateOrderBread
  | DeleteOrderBread
  | SuccessDeleteOrderBread
  | FailDeleteOrderBread
  | InitOrderBread;

/**
 * Get
 */
interface GetOrderBread {
  type: typeof types.GET_ORDER_BREAD;
  payload: {
    id: string;
  };
}
export const getOrderBread = (payload: GetOrderBread['payload']) => ({
  type: types.GET_ORDER_BREAD,
  payload,
});

interface SuccessGetOrderBread {
  type: typeof types.SUCCESS_GET_ORDER_BREAD;
  payload: APISuccessfulResponse<OrderBreadEntity>;
}
export const successGetOrderBread = (payload: SuccessGetOrderBread['payload']) => ({
  type: types.SUCCESS_GET_ORDER_BREAD,
  payload,
});

interface FailGetOrderBread {
  type: typeof types.FAIL_GET_ORDER_BREAD;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetOrderBread = (payload: FailGetOrderBread['payload']) => ({
  type: types.FAIL_GET_ORDER_BREAD,
  payload,
});

/**
 * Get (multiple)
 */
interface GetOrderBreads {
  type: typeof types.GET_ORDER_BREADS;
  payload: {
    shopId: string;
  };
}
export const getOrderBreads = (payload: GetOrderBreads['payload']) => ({
  type: types.GET_ORDER_BREADS,
  payload,
});

interface SuccessGetOrderBreads {
  type: typeof types.SUCCESS_GET_ORDER_BREADS;
  payload: APISuccessfulResponse<OrderBreadEntity[]>;
}
export const successGetOrderBreads = (payload: SuccessGetOrderBreads['payload']) => ({
  type: types.SUCCESS_GET_ORDER_BREADS,
  payload,
});

interface FailGetOrderBreads {
  type: typeof types.FAIL_GET_ORDER_BREADS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetOrderBreads = (payload: FailGetOrderBreads['payload']) => ({
  type: types.FAIL_GET_ORDER_BREADS,
  payload,
});

/**
 * Validate
 */
interface ValidateOrderBread {
  type: typeof types.VALIDATE_ORDER_BREAD;
  payload: OrderBreadEntity;
}
export const validateOrderBread = (payload: ValidateOrderBread['payload']) => ({
  type: types.VALIDATE_ORDER_BREAD,
  payload,
});

interface SuccessValidateOrderBread {
  type: typeof types.SUCCESS_VALIDATE_ORDER_BREAD;
  payload: APISuccessfulResponse<OrderBreadEntity>;
}
export const successValidateOrderBread = (payload: SuccessValidateOrderBread['payload']) => ({
  type: types.SUCCESS_VALIDATE_ORDER_BREAD,
  payload,
});

interface FailValidateOrderBread {
  type: typeof types.FAIL_VALIDATE_ORDER_BREAD;
  payload: ValidationResponse | APIFailedResponse;
}
export const failValidateOrderBread = (payload: FailValidateOrderBread['payload']) => ({
  type: types.FAIL_VALIDATE_ORDER_BREAD,
  payload,
});

/**
 * Create
 */
interface CreateOrderBread {
  type: typeof types.CREATE_ORDER_BREAD;
  payload: OrderBreadEntity;
}
export const createOrderBread = (payload: CreateOrderBread['payload']) => ({
  type: types.CREATE_ORDER_BREAD,
  payload,
});

interface SuccessCreateOrderBread {
  type: typeof types.SUCCESS_CREATE_ORDER_BREAD;
  payload: APISuccessfulResponse<OrderBreadEntity>;
}
export const successCreateOrderBread = (payload: SuccessCreateOrderBread['payload']) => ({
  type: types.SUCCESS_CREATE_ORDER_BREAD,
  payload,
});

interface FailCreateOrderBread {
  type: typeof types.FAIL_CREATE_ORDER_BREAD;
  payload: ValidationResponse | APIFailedResponse;
}
export const failCreateOrderBread = (payload: FailCreateOrderBread['payload']) => ({
  type: types.FAIL_CREATE_ORDER_BREAD,
  payload,
});

/**
 * Delete
 */
interface DeleteOrderBread {
  type: typeof types.DELETE_ORDER_BREAD;
  payload: string;
}
export const deleteOrderBread = (payload: DeleteOrderBread['payload']) => ({
  type: types.DELETE_ORDER_BREAD,
  payload,
});

interface SuccessDeleteOrderBread {
  type: typeof types.SUCCESS_DELETE_ORDER_BREAD;
  payload: APISuccessfulResponse<OrderBreadEntity>;
}
export const successDeleteOrderBread = (payload: SuccessDeleteOrderBread['payload']) => ({
  type: types.SUCCESS_DELETE_ORDER_BREAD,
  payload,
});

interface FailDeleteOrderBread {
  type: typeof types.FAIL_DELETE_ORDER_BREAD;
  payload: ValidationResponse | APIFailedResponse;
}
export const failDeleteOrderBread = (payload: FailDeleteOrderBread['payload']) => ({
  type: types.FAIL_DELETE_ORDER_BREAD,
  payload,
});

interface GetNotificationOrderBreads {
  type: typeof types.GET_NOTIFICATION_ORDER_BREADS;
  payload: {
    shopId: string;
    notificationId: string;
  };
}
export const getNotificationOrderBreads = (payload: GetNotificationOrderBreads['payload']) => ({
  type: types.GET_NOTIFICATION_ORDER_BREADS,
  payload,
});

interface SuccessGetNotificationOrderBreads {
  type: typeof types.SUCCESS_GET_NOTIFICATION_ORDER_BREADS;
  payload: APISuccessfulResponse<OrderBreadEntity[]>;
}
export const successGetNotificationOrderBreads = (
  payload: SuccessGetNotificationOrderBreads['payload'],
) => ({
  type: types.SUCCESS_GET_NOTIFICATION_ORDER_BREADS,
  payload,
});

interface FailGetNotificationOrderBreads {
  type: typeof types.FAIL_GET_NOTIFICATION_ORDER_BREADS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetNotificationOrderBreads = (
  payload: FailGetNotificationOrderBreads['payload'],
) => ({
  type: types.FAIL_GET_NOTIFICATION_ORDER_BREADS,
  payload,
});

interface GetDayOrderBreads {
  type: typeof types.GET_DAY_ORDER_BREADS;
  payload: {
    shopId: string;
    startDate: Date;
    endDate: Date;
  };
}
export const getDayOrderBreads = (payload: GetDayOrderBreads['payload']) => ({
  type: types.GET_DAY_ORDER_BREADS,
  payload,
});

interface SuccessGetDayOrderBreads {
  type: typeof types.SUCCESS_GET_DAY_ORDER_BREADS;
  payload: APISuccessfulResponse<OrderBreadEntity[]>;
}
export const successGetDayOrderBreads = (payload: SuccessGetDayOrderBreads['payload']) => ({
  type: types.SUCCESS_GET_DAY_ORDER_BREADS,
  payload,
});

interface FailGetDayOrderBreads {
  type: typeof types.FAIL_GET_DAY_ORDER_BREADS;
  payload: ValidationResponse | APIFailedResponse;
}
export const failGetDayOrderBreads = (payload: FailGetDayOrderBreads['payload']) => ({
  type: types.FAIL_GET_DAY_ORDER_BREADS,
  payload,
});

/**
 * Init state
 */
interface InitOrderBread {
  type: typeof types.INIT_ORDER_BREAD;
}
export const initOrderBread = () => ({
  type: types.INIT_ORDER_BREAD,
});
